import { isAccountActive } from "./utils/userAccess";

/**
 * The account's single, immutable context. This app serves only the student and
 * teacher dashboards; an admin account authenticates against the separate admin
 * dashboard, so `admin` is intentionally not a value here — an admin payload is
 * treated as "not a dashboard user" by the auth gate.
 */
export type AccountType = "student" | "teacher";

export type AuthUser = {
  name?: string;
  is_active?: boolean | number | null;
  account_type?: AccountType | null;
} & Record<string, unknown>;

export function isAccountType(value: unknown): value is AccountType {
  return value === "student" || value === "teacher";
}

/**
 * Unused today (no call sites) — kept only because its name suggests a
 * general-purpose "can this user do things" check. Delegates to
 * isAccountActive() rather than reading user.is_active directly, so if this
 * ever gets wired up it inherits activation from the primary account for a
 * switched-into sub-user session instead of re-introducing the bug that
 * check was fixed for.
 */
export function isAllowedAuthenticatedUser(user: unknown): user is AuthUser {
  if (!isRecord(user)) {
    return false;
  }

  return isAccountActive(user) && isAccountType(user.account_type);
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
